import clsx from "clsx";
import {
  SURFACE_FEATURED,
  SURFACE_INSET,
  SURFACE_RAISED_SOLID,
  STATUS_AGENT_BG,
  STATUS_AGENT_TEXT,
} from "@/components/ui/surface/surfaceTokens";

/**
 * Shared surfaces for agentic UI primitives.
 * Dark-first, elevation over hairline borders (matches design-system/catalog-surfaces).
 */

/** Default elevated panel (intent preview, generic cards). */
export const AGENTIC_PANEL_CLASS = clsx(
  "w-full max-w-lg rounded-xl p-6 text-sm",
  SURFACE_RAISED_SOLID,
  "text-slate-900 dark:text-slate-100",
);

/** Human-in-the-loop / approval emphasis — featured indigo, not amber hairline. */
export const AGENTIC_HITL_PANEL_CLASS = clsx(
  "w-full max-w-lg rounded-xl p-6 text-sm shadow-sm dark:shadow-md dark:shadow-black/35",
  SURFACE_FEATURED,
  "text-slate-900 dark:text-slate-100",
);

/** Footer row for panel primary/secondary actions — matches `DialogActions` spacing. */
export const AGENTIC_PANEL_ACTIONS_CLASS = "mt-6 flex flex-wrap justify-end gap-2";

/** Inset metadata (receipts, handoffs, cost). */
export const AGENTIC_INSET_PANEL_CLASS = clsx(
  "rounded-lg px-3 py-2.5 text-sm",
  SURFACE_INSET,
  "text-slate-800 dark:text-slate-200",
);

/** Persistent agent-acting indicator. */
export const AGENTIC_PRESENCE_CLASS = clsx(
  "flex items-center gap-2 rounded-lg px-3 py-2 text-xs shadow-sm dark:shadow-md dark:shadow-black/35",
  STATUS_AGENT_BG,
  STATUS_AGENT_TEXT,
);

export const AGENTIC_AGENT_BUBBLE_CLASS = clsx(
  "rounded-2xl rounded-tl-md px-3.5 py-3 text-sm",
  "bg-indigo-500/[0.08] text-slate-800 dark:text-slate-200",
);

export const AGENTIC_USER_BUBBLE_CLASS = clsx(
  "rounded-2xl rounded-tr-md px-3.5 py-3 text-sm",
  "bg-slate-100 text-slate-900 dark:bg-white/[0.06] dark:text-slate-100",
);

export const AGENTIC_SYSTEM_BUBBLE_CLASS = clsx(
  "rounded-xl px-3.5 py-3 text-sm",
  "bg-slate-100 text-slate-700 dark:bg-white/5 dark:text-slate-300",
);

export const AGENTIC_THOUGHT_SUMMARY_CLASS = clsx(
  "rounded-2xl rounded-tl-md px-3.5 py-2.5 text-sm",
  "bg-indigo-500/[0.06] dark:bg-indigo-500/[0.08]",
);

export const AGENTIC_THOUGHT_BODY_CLASS = clsx(
  "rounded-2xl rounded-tl-md px-3.5 py-3 text-sm",
  "bg-indigo-500/[0.04] text-slate-700 dark:bg-indigo-500/[0.06] dark:text-slate-300",
);
